import { Component, OnInit } from '@angular/core';
import { BannerReasonComponent } from './component/banner-reason/banner-reason.component';
import { NuestrosAliadosComponent } from './component/nuestros-aliados/nuestros-aliados.component';
import { NuestroEquipoComponent } from './component/nuestro-equipo/nuestro-equipo.component';
import { EstadisticsReasonComponent } from './component/estadistics-reason/estadistics-reason.component';
import { NuestroEquipoMediaComponent } from './component/nuestro-equipo-media/nuestro-equipo-media.component';

@Component({
  selector: 'app-reason',
  templateUrl: './reason.component.html',
  styleUrls: ['./reason.component.scss'],
  imports: [BannerReasonComponent,
    NuestrosAliadosComponent,
    NuestroEquipoComponent,
    EstadisticsReasonComponent,
    NuestroEquipoMediaComponent
  ],
  standalone: true
})
export class ReasonComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

}
